// Generated file : do not modify
import { AdminConfig } from '@/extend/classes/Admin';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Données d'une liste
export class ListItem {
  // 
  public obj: unknown;
  // 
  public config: ListConfig;

  constructor() {
    this.obj = null;
    this.config = new ListConfig();
  }
}

export class ListChoix {
  // 
  public value: number;
  // 
  public text: string;
  // 
  public count: number;
  // 
  public dateRange: DateRange | null;

  constructor() {
    this.value = 0;
    this.text = '';
    this.count = 0;
    this.dateRange = null;
  }
}

export class DateRange {
  // 
  public dateDebut: Date;
  // 
  public dateFin: Date;

  constructor() {
    this.dateDebut = new Date(1901,1,1,0,0,0,0);
    this.dateFin = new Date(1901,1,1,0,0,0,0);
  }
}

export class ListConfig {
  // 
  public columnsConfig: ColumnConfig[];

  constructor() {
    this.columnsConfig = [];
  }
}

export class ColumnConfig {
  // Nom de l'attribut de la colonne
  public name: string;
  // 
  public isFilterable: boolean;
  // 
  public choix: ListChoix[];
  // 
  public type: string;

  constructor() {
    this.name = '';
    this.isFilterable = false;
    this.choix = [];
    this.type = '';
  }
}

export class ListFilter {
  // 
  public page: number;
  // 
  public displayedHeaders: string[];
  // 
  public searchText: string;
  // 
  public tableName: string;
  // 
  public columnsFilter: ColumnFilter[];
  // 
  public selectedId: number;
  // 
  public pageLimit: number;

  constructor() {
    this.page = 0;
    this.displayedHeaders = [];
    this.searchText = '';
    this.tableName = '';
    this.columnsFilter = [];
    this.selectedId = 0;
    this.pageLimit = 0;
  }
}

export class ColumnFilter {
  // Nom de l'attribut de la colonne
  public name: string;
  // 
  public sortAscending: boolean;
  // 
  public sortDescending: boolean;
  // 
  public staticFilter: boolean;
  // 
  public filters: ListChoix[];

  constructor() {
    this.name = '';
    this.sortAscending = false;
    this.sortDescending = false;
    this.staticFilter = false;
    this.filters = [];
  }
}

export default class ListData  {
  // 
  public config: ListConfig;
  // 
  public reccords: unknown[];
  // 
  public adminConfig: AdminConfig;
  // 
  public pageCount: number;
  // 
  public totalCount: number;
  // 
  public filteredCount: number;
  // 
  public currentPage: number;

  constructor() {
    this.config = new ListConfig();
    this.reccords = [];
    this.adminConfig = new AdminConfig();
    this.pageCount = 0;
    this.totalCount = 0;
    this.filteredCount = 0;
    this.currentPage = 0;
  }

  public static fromJson (obj: ListData): ListData {
    const newListData: ListData = new ListData();
    newListData.config = JSON.parse(JSON.stringify(obj.config));
    newListData.reccords = JSON.parse(JSON.stringify(obj.reccords));
    newListData.adminConfig = JSON.parse(JSON.stringify(obj.adminConfig));
    newListData.pageCount = obj.pageCount;
    newListData.totalCount = obj.totalCount;
    newListData.filteredCount = obj.filteredCount;
    newListData.currentPage = obj.currentPage;
    return newListData;
  }

  public toJsonListData (): string {
    const json = {
      config: this.config,
      reccords: this.reccords,
      adminConfig: this.adminConfig,
      pageCount: this.pageCount,
      totalCount: this.totalCount,
      filteredCount: this.filteredCount,
      currentPage: this.currentPage,
    }
    return JSON.stringify(json);
  }

  public fromListData (obj: ListData): void {
    this.config = obj.config;
    this.reccords = obj.reccords;
    this.adminConfig = obj.adminConfig;
    this.pageCount = obj.pageCount;
    this.totalCount = obj.totalCount;
    this.filteredCount = obj.filteredCount;
    this.currentPage = obj.currentPage;
  }

  public compareListData (value: ListData): boolean {
    return (this.toJsonListData() == value.toJsonListData());
  }

  public cloneListData (): ListData {
    return ListData.fromJson(this);
  }

  // eslint-disable-next-line
  public static getDate(listDatas: ListData[]) {
  }
}
